import axios from "axios";
import { ENDPOINTS } from "data/endpoints";

import { ROUTES } from "./constants";
import { logout } from "./Utils";

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !error.config.url.includes(ENDPOINTS.LOGIN)
    ) {
      logout();
      window.location.href = ROUTES.LOGIN;
    }
    return Promise.reject(error);
  },
);

export const getAxios = () => {
  return axios;
};
